export default function Reset(props)
{
  return <svg {...props} width="24px" height="24px" fill="currentcolor" version="1.1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="m6.36 6.35c1.45-1.45 3.44-2.35 5.65-2.35 4.42 0 7.99 3.58 7.99 8s-3.57 8-7.99 8c-3.73 0-6.84-2.55-7.73-6h2.08c0.82 2.33 3.04 4 5.65 4 3.31 0 6-2.69 6-6s-2.69-6-6-6c-1.66 0-3.14 0.69-4.22 1.78l3.22 3.22h-7v-7z"/>
  </svg>;
}
